import axios from "axios"
import GatsbyConfig from "../../gatsby-config"
import { navigate } from "gatsby"

//import { withPrefix } from "gatsby"

// export const getAutofillData = () => {
//   //   let result =
//   return axios
//     .post(withPrefix("/Claim/GetData"), null)
//     .then(function(response) {
//       return response
//     })

//   //   return result
// }

export const apiPostRequest = (url, data, config) => {
  const apiPreFix = GatsbyConfig.siteMetadata.apiPreFix

  let preFix = process.env.NODE_ENV !== "development" ? apiPreFix : ""

   if (config == null) {
     config = { timeout: 300000 } //300000 = 5 mins
   } else {
     config = { ...config, timeout: 300000 }
   }

  return axios
    .post(preFix + url, data, config)
    .then(function(response) {
      return response
    })
    .catch(function(error) {
      console.log(error.response)
      console.log(error.response.data)
      navigate("ErrorOccurred")
    })
}
